module.exports = __webpack_public_path__ + "static/img/gywm.04a71ed6.png";